// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ActivitiesPage.css - Based on Figma Design System */

.activities-page {
  width: 100%;
  min-height: 100%;
  background-color: #F4F4F4;
  padding: 40px 0;
}

.activities-loading,
.activities-error {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 18px;
  color: #21262A;
}

.activities-error {
  color: #D32F2F;
}

.activities-content {
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 1540px;
  margin: 0 auto;
  padding: 0 40px;
}

/* Header */
.activities-header {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.activities-title {
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 900;
  font-size: 48px;
  line-height: 1.2;
  letter-spacing: -0.005em;
  color: #236CFF;
  margin: 0;
}

.activities-description {
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.6;
  color: #21262A;
  margin: 0;
  max-width: 700px;
}

/* Carousel Navigation */
.carousel-nav {
  display: flex;
  gap: 12px;
  margin-top: 8px;
  align-self: flex-end;
}

.carousel-nav-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background-color: #FFFFFF;
  border: 2px solid #D5DEE3;
  border-radius: 50%;
  cursor: pointer;
  color: #21262A;
  transition: all 0.2s ease;
}

.carousel-nav-btn:hover:not(.carousel-nav-btn-disabled) {
  background-color: #236CFF;
  border-color: #236CFF;
  color: #FFFFFF;
}

.carousel-nav-btn:focus {
  outline: 2px solid #236CFF;
  outline-offset: 2px;
}

.carousel-nav-btn-disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* Carousel Wrapper */
.activities-carousel-wrapper {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.activities-carousel {
  display: flex;
  gap: 24px;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding: 8px 0;
}

.activities-carousel::-webkit-scrollbar {
  display: none;
}

/* Activity Card */
.activity-card {
  display: flex;
  flex-direction: column;
  width: 356px;
  min-width: 356px;
  background-color: #FFFFFF;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  scroll-snap-align: start;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.activity-card:hover {
  transform: translateY(-4px);
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.15);
}

/* Card Image */
.activity-card-image {
  position: relative;
  width: 100%;
  height: 180px;
  background: linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%);
  overflow: hidden;
}

/* Category overlay on image */
.activity-category {
  position: absolute;
  top: 12px;
  right: 12px;
  display: inline-flex;
  padding: 6px 12px;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #236CFF;
}

.activity-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Card Content */
.activity-card-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  flex: 1;
}

.activity-card-title {
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 1.3;
  color: #21262A;
  margin: 0;
}

.activity-card-description {
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  color: #5F696F;
  margin: 0;
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Card Footer - Duration and Button */
.activity-card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: auto;
}

.activity-duration {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: 1.5px solid #21262A;
  border-radius: 8px;
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #21262A;
}

.activity-duration svg {
  color: #21262A;
}

.activity-start-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 32px;
  background-color: #00254B;
  border: none;
  border-radius: 9999px;
  cursor: pointer;
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #FFFFFF;
  transition: background-color 0.2s ease;
}

.activity-start-btn:hover {
  background-color: #001a35;
}

.activity-start-btn:focus {
  outline: 2px solid #1C60EA;
  outline-offset: 2px;
}

/* Completion Card */
.completion-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 356px;
  min-width: 356px;
  padding: 60px 32px;
  background-color: #FFFFFF;
  border-radius: 16px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  scroll-snap-align: start;
  box-sizing: border-box;
}

.completion-card-title {
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 1.3;
  color: #21262A;
  margin: 0 0 16px 0;
}

.completion-card-description {
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  color: #5F696F;
  margin: 0 0 32px 0;
}

.completion-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 48px;
  background-color: transparent;
  border: 2px solid #00254B;
  border-radius: 9999px;
  cursor: pointer;
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #00254B;
  transition: all 0.2s ease;
}

.completion-btn:hover {
  background-color: #00254B;
  color: #FFFFFF;
}

.completion-btn:focus {
  outline: 2px solid #00254B;
  outline-offset: 2px;
}

/* Responsive */
@media (max-width: 900px) {
  .activities-content {
    padding: 0 24px;
  }

  .activities-title {
    font-size: 36px;
  }

  .activity-card,
  .completion-card {
    width: 300px;
    min-width: 300px;
  }

  .activity-card-image {
    height: 150px;
  }
}

@media (max-width: 600px) {
  .activities-title {
    font-size: 28px;
  }

  .activities-description {
    font-size: 16px;
  }

  .activity-card,
  .completion-card {
    width: 280px;
    min-width: 280px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/ActivitiesPage.css"],"names":[],"mappings":"AAAA,sDAAsD;;AAEtD;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kFAAkF;EAClF,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,wBAAwB;EACxB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,6DAA6D;EAC7D,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,2CAA2C;EAC3C,mBAAmB;EACnB,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,OAAO;AACT;;AAEA;EACE,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,OAAO;EACP,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;EAClB;AACF","sourcesContent":["/* ActivitiesPage.css - Based on Figma Design System */\n\n.activities-page {\n  width: 100%;\n  min-height: 100%;\n  background-color: #F4F4F4;\n  padding: 40px 0;\n}\n\n.activities-loading,\n.activities-error {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 18px;\n  color: #21262A;\n}\n\n.activities-error {\n  color: #D32F2F;\n}\n\n.activities-content {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  max-width: 1540px;\n  margin: 0 auto;\n  padding: 0 40px;\n}\n\n/* Header */\n.activities-header {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.activities-title {\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 900;\n  font-size: 48px;\n  line-height: 1.2;\n  letter-spacing: -0.005em;\n  color: #236CFF;\n  margin: 0;\n}\n\n.activities-description {\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 1.6;\n  color: #21262A;\n  margin: 0;\n  max-width: 700px;\n}\n\n/* Carousel Navigation */\n.carousel-nav {\n  display: flex;\n  gap: 12px;\n  margin-top: 8px;\n  align-self: flex-end;\n}\n\n.carousel-nav-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  background-color: #FFFFFF;\n  border: 2px solid #D5DEE3;\n  border-radius: 50%;\n  cursor: pointer;\n  color: #21262A;\n  transition: all 0.2s ease;\n}\n\n.carousel-nav-btn:hover:not(.carousel-nav-btn-disabled) {\n  background-color: #236CFF;\n  border-color: #236CFF;\n  color: #FFFFFF;\n}\n\n.carousel-nav-btn:focus {\n  outline: 2px solid #236CFF;\n  outline-offset: 2px;\n}\n\n.carousel-nav-btn-disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* Carousel Wrapper */\n.activities-carousel-wrapper {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n\n.activities-carousel {\n  display: flex;\n  gap: 24px;\n  overflow-x: auto;\n  scroll-snap-type: x mandatory;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  padding: 8px 0;\n}\n\n.activities-carousel::-webkit-scrollbar {\n  display: none;\n}\n\n/* Activity Card */\n.activity-card {\n  display: flex;\n  flex-direction: column;\n  width: 356px;\n  min-width: 356px;\n  background-color: #FFFFFF;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);\n  scroll-snap-align: start;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.activity-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.15);\n}\n\n/* Card Image */\n.activity-card-image {\n  position: relative;\n  width: 100%;\n  height: 180px;\n  background: linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%);\n  overflow: hidden;\n}\n\n/* Category overlay on image */\n.activity-category {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  display: inline-flex;\n  padding: 6px 12px;\n  background-color: rgba(255, 255, 255, 0.95);\n  border-radius: 12px;\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 600;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #236CFF;\n}\n\n.activity-card-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Card Content */\n.activity-card-content {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 20px;\n  flex: 1;\n}\n\n.activity-card-title {\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 1.3;\n  color: #21262A;\n  margin: 0;\n}\n\n.activity-card-description {\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #5F696F;\n  margin: 0;\n  flex: 1;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* Card Footer - Duration and Button */\n.activity-card-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-top: auto;\n}\n\n.activity-duration {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  border: 1.5px solid #21262A;\n  border-radius: 8px;\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  color: #21262A;\n}\n\n.activity-duration svg {\n  color: #21262A;\n}\n\n.activity-start-btn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 10px 32px;\n  background-color: #00254B;\n  border: none;\n  border-radius: 9999px;\n  cursor: pointer;\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  color: #FFFFFF;\n  transition: background-color 0.2s ease;\n}\n\n.activity-start-btn:hover {\n  background-color: #001a35;\n}\n\n.activity-start-btn:focus {\n  outline: 2px solid #1C60EA;\n  outline-offset: 2px;\n}\n\n/* Completion Card */\n.completion-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  width: 356px;\n  min-width: 356px;\n  padding: 60px 32px;\n  background-color: #FFFFFF;\n  border-radius: 16px;\n  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);\n  scroll-snap-align: start;\n  box-sizing: border-box;\n}\n\n.completion-card-title {\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 1.3;\n  color: #21262A;\n  margin: 0 0 16px 0;\n}\n\n.completion-card-description {\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #5F696F;\n  margin: 0 0 32px 0;\n}\n\n.completion-btn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 12px 48px;\n  background-color: transparent;\n  border: 2px solid #00254B;\n  border-radius: 9999px;\n  cursor: pointer;\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  color: #00254B;\n  transition: all 0.2s ease;\n}\n\n.completion-btn:hover {\n  background-color: #00254B;\n  color: #FFFFFF;\n}\n\n.completion-btn:focus {\n  outline: 2px solid #00254B;\n  outline-offset: 2px;\n}\n\n/* Responsive */\n@media (max-width: 900px) {\n  .activities-content {\n    padding: 0 24px;\n  }\n\n  .activities-title {\n    font-size: 36px;\n  }\n\n  .activity-card,\n  .completion-card {\n    width: 300px;\n    min-width: 300px;\n  }\n\n  .activity-card-image {\n    height: 150px;\n  }\n}\n\n@media (max-width: 600px) {\n  .activities-title {\n    font-size: 28px;\n  }\n\n  .activities-description {\n    font-size: 16px;\n  }\n\n  .activity-card,\n  .completion-card {\n    width: 280px;\n    min-width: 280px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
